import { captureException } from '@sentry/react';
import { getApiUsersMeQueryOptions } from '@shape-construction/api/src-global/hooks/useGetApiUsersMe';
import { showErrorToast } from '@shape-construction/arch-ui/src/Toast/toasts';
import { dedupePromise } from '@shape-construction/utils/promises/dedupe';
import { globalAxiosInstance } from 'app/axios';
import { environment } from 'app/config/environment';
import axios from 'axios';
import { getRefreshToken, getToken, setRefreshToken, setToken } from './authorization';
import queryClient from './queries/query.client.builder';
const getConsentData = () => window?.CookieConsent?.consent || null;
const cookieConsentHeaderContent = ({
  statistics
}) => JSON.stringify({
  statistics
});
export const setupAuthorizationHeader = request => {
  const config = {
    ...request
  };
  config.headers = config.headers ?? {};
  config.headers['X-Shape-User-Agent'] = `ShapeApp/${environment.VERSION}`; // eslint-disable-line no-param-reassign

  const authorization = getToken();
  if (authorization) {
    config.headers.Authorization = authorization;
  }
  const consentData = getConsentData();
  if (consentData) {
    config.headers['Tracker-Consent'] = cookieConsentHeaderContent(consentData);
  }
  return config;
};
export const preserveAuthorizationHeaders = response => {
  const authorization = response.headers.authorization;
  if (authorization) {
    setToken(authorization);
  }
  const refreshToken = response.headers['authorization-refresh'];
  if (refreshToken) {
    setRefreshToken(refreshToken);
  }
};
export const onMaintenanceMode = () => {
  window.location.assign('/maintenance.html');
};
export const onMutateError = error => {
  const errorMessage = error.response?.data?.errorDescription ?? error?.message ?? 'Something went wrong';
  showErrorToast({
    id: errorMessage,
    message: errorMessage
  });
};
export const refreshAuthToken = dedupePromise(async () => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    captureException(new Error('No refresh token found'));
    throw new Error('No refresh token found');
  }
  const response = await axios('/api/login/refresh', {
    method: 'POST',
    headers: {
      'Authorization-Refresh': refreshToken,
      'X-Shape-User-Agent': `ShapeApp/${environment.VERSION}`
    },
    // Auth is a global endpoint — use the global API base URL
    baseURL: globalAxiosInstance.defaults.baseURL
  });
  preserveAuthorizationHeaders(response);
  return response;
});
export const onNotAcceptedEndUserAgreement = () => {
  const user = queryClient.getQueryData(getApiUsersMeQueryOptions().queryKey);
  if (user) {
    queryClient.setQueryData(getApiUsersMeQueryOptions().queryKey, {
      ...user,
      pendingEuaAcceptance: true
    });
  }
};